import isValidEmail from "./isValidEmail";
import isValidPassword from "./isValidPassword";

export default {
    isValidEmail,
    isValidPassword,
}